import { render } from "./FicheCollab.vue?vue&type=template&id=48812f26&scoped=true"
import script from "./FicheCollab.vue?vue&type=script&lang=js"
export * from "./FicheCollab.vue?vue&type=script&lang=js"

import "./FicheCollab.vue?vue&type=style&index=0&id=48812f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48812f26"]])

export default __exports__